import React from "react";
import styles from "../WidgetAppearanceForm.module.css";
import {
    AppearanceTabSettingsContainer
} from "../../../../../../../elements/appearanceTabSettingsContainer/AppearanceTabSettingsContainer";
import {useAppDispatch, useAppSelector} from "../../../../../../../../app/hooks";
import {ValidatedTextAreaField} from "../../../../../../../elements/validator/component/ValidatedTextAreaField";
import {NotEmptyStringValidator} from "../../../../../../../elements/validator/Validator";
import {
    selectChatConvoStarters,
    selectInitialBotMessage,
    updateChatConvoStarters,
    updateLocalizedField
} from "../../../widgetAppearanceUpdateSlice";
import {PromptButton} from "../../../../../../../elements/PromptButtonInput/PromptButton";
import {AddButton} from "../../../../../../../elements/addButton/AddButton";

interface WidgetViewProps {
    getMessageWrapper: (field: string) => string;
    updateValidationStatus: any;
}

export const WidgetView: React.FC<WidgetViewProps> = ({
                                                          getMessageWrapper,
                                                          updateValidationStatus
                                                      }) => {
    const dispatch = useAppDispatch();
    const chatConvoStarters = useAppSelector(selectChatConvoStarters) || [];

    const handleAddChatButton = () => {
        if (chatConvoStarters.length < 5) {
            const newButtons = [...chatConvoStarters, ""];
            dispatch(updateChatConvoStarters(newButtons));
        }
    };

    const handleUpdateChatButton = (index: number, value: string) => {
        const newButtons = [...chatConvoStarters];
        newButtons[index] = value;
        dispatch(updateChatConvoStarters(newButtons));
    };

    const handleDeleteChatButton = (index: number) => {
        const newButtons = chatConvoStarters.filter((_, i) => i !== index);
        dispatch(updateChatConvoStarters(newButtons));
    };

    return (
        <AppearanceTabSettingsContainer
            title="Widget View"
            withSwitch={false}
        >
            <div className={styles.fieldsLine}>
                <ValidatedTextAreaField
                    onChange={(v) => dispatch(updateLocalizedField({
                        field: "initialBotMessage",
                        value: v
                    }))}
                    updateValidationStatus={updateValidationStatus}
                    fieldName="initialBotMessage"
                    selector={selectInitialBotMessage}
                    validator={NotEmptyStringValidator}
                    label="Opening message"
                    maxLength={255}
                    placeholder="Hi, I'm AIME, your AI assistant. How can I help you {time}?"
                    getMessage={getMessageWrapper}
                />
            </div>
            <p className={styles.fieldHint}>
                {"{time}"} is replaced with "this morning", "this afternoon" or "this evening".
            </p>

            <div className={styles.promptButtonsSection}>
                <label className={styles.promptButtonsLabel}>Prompt Buttons</label>
                <div className={styles.promptButtonsList}>
                    {chatConvoStarters.map((button, index) => (
                        <PromptButton
                            key={index}
                            value={button}
                            onChange={(value) => handleUpdateChatButton(index, value)}
                            onDelete={() => handleDeleteChatButton(index)}
                            maxLength={30}
                            placeholder={`Placeholder ${index + 1}`}
                        />
                    ))}
                </div>

                <AddButton
                    onClick={handleAddChatButton}
                    isEnabled={chatConvoStarters.length < 5}
                    text="Add Prompt Button"
                />
            </div>
        </AppearanceTabSettingsContainer>
    );
};
